var Transition = {
	/**
	 * Easing equation function for a simple linear tweening, with no easing.
	 *
	 * @param {number} t	Current time/phase (0-1).
	 * @return {number}		The new value/phase (0-1).
	 */
	linear: function linear(t) {
		return t;
	},

	/**
	 * Easing equation function for a quadratic (t^2) easing in: accelerating from zero velocity.
	 *
	 * @param {number} t	Current time/phase (0-1).
	 * @return {number}		The new value/phase (0-1).
	 */
	quadIn: function quadIn(t) {
		return t * t;
	},

	/**
	 * Easing equation function for a quadratic (t^2) easing out: decelerating to zero velocity.
	 *
	 * @param {number} t	Current time/phase (0-1).
	 * @return {number}		The new value/phase (0-1).
	 */
	quadOut: function quadOut(t) {
		return -t * (t - 2);
	},

	/**
	 * Easing equation function for a quadratic (t^2) easing in and then out: accelerating from zero velocity, then decelerating.
	 *
	 * @param {number} t	Current time/phase (0-1).
	 * @return {number}		The new value/phase (0-1).
	 */
	quadInOut: function quadInOut(t) {
		//return t < 0.5 ? quadIn(t*2) : quadOut((t-0.5)*2);
		return ((t *= 2) < 1) ? t * t * 0.5 : -0.5 * (--t * (t - 2) - 1);
	},

	/**
	 * Easing equation function for a cubic (t^3) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	cubicIn: function cubicIn(t) {
		return t * t * t;
	},

	/**
	 * Easing equation function for a cubic (t^3) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	cubicOut: function cubicOut(t) {
		return (t -= 1) * t * t + 1;
	},

	cubicInOut: function cubicInOut(t) {
		return (t *= 2) < 1 ? Transition.cubicIn(t) / 2 : Transition.cubicOut(t - 1) / 2 + 0.5; // TODO: redo with in-line calculation
	},

	/**
	 * Easing equation function for a quartic (t^4) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	quartIn: function quartIn(t) {
		return t * t * t * t;
	},

	/**
	 * Easing equation function for a quartic (t^4) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	quartOut: function quartOut(t) {
		t--;
		return -1 * (t * t * t * t - 1);
	},

	quartInOut: function quartInOut(t) {
		return (t *= 2) < 1 ? Transition.quartIn(t) / 2 : Transition.quartOut(t - 1) / 2 + 0.5; // TODO: redo with in-line calculation
	},

	/**
	 * Easing equation function for a quintic (t^5) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	quintIn: function quintIn(t) {
		return t * t * t * t * t;
	},

	/**
	 * Easing equation function for a quintic (t^5) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	quintOut: function quintOut(t) {
		t--;
		return t * t * t * t * t + 1;
	},

	quintInOut: function quintInOut(t) {
		return (t *= 2) < 1 ? Transition.quintIn(t) / 2 : Transition.quintOut(t - 1) / 2 + 0.5; // TODO: redo with in-line calculation
	},

	/**
	 * Easing equation function for a sinusoidal (sin(t)) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	sineIn: function sineIn(t) {
		return -1 * Math.cos(t * Math.PI / 2) + 1;
	},

	/**
	 * Easing equation function for a sinusoidal (sin(t)) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	sineOut: function sineOut(t) {
		return Math.sin(t * Math.PI / 2);
	},

	sineInOut: function sineInOut(t) {
		return (t *= 2) < 1 ? Transition.sineIn(t) / 2 : Transition.sineOut(t - 1) / 2 + 0.5; // TODO: redo with in-line calculation
	},

	/**
	 * Easing equation function for an exponential (2^t) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	expoIn: function expoIn(t) {
		// return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b; // original
		// return (t==0) ? 0 : Math.pow(2, 10 * (t - 1)); // ztween
		// return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b - c * 0.001; // tweener fixed
		return (t == 0) ? 0 : Math.pow(2, 10 * (t - 1)) - 0.001; // ztween fixed
	},

	/**
	 * Easing equation function for an exponential (2^t) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	expoOut: function expoOut(t) {
		// return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b; // original
		// return (t==1) ? 1 : (-Math.pow(2, -10 * t) + 1); // ztween
		// return (t == d) ? b + c : c * 1.001 * (-Math.pow(2, -10 * t / d) + 1) + b; // tweener fixed
		//log(">", t, (t==1) ? 1 : 1.001 * (-Math.pow(2, -10 * t) + 1))
		//return (t==1) ? 1 : 1.001 * (-Math.pow(2, -10 * t) + 1); // ztween fixed
		return (t >= 0.999) ? 1 : 1.001 * (-Math.pow(2, -10 * t) + 1); // ztween fixed 2
	},

	expoInOut: function expoInOut(t) {
		return (t *= 2) < 1 ? Transition.expoIn(t) / 2 : Transition.expoOut(t - 1) / 2 + 0.5; // TODO: redo with in-line calculation
	},

	/**
	 * Easing equation function for a circular (sqrt(1-t^2)) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	circIn: function circIn(t) {
		return -1 * (Math.sqrt(1 - t * t) - 1);
	},

	/**
	 * Easing equation function for a circular (sqrt(1-t^2)) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	circOut: function circOut(t) {
		t--;
		return Math.sqrt(1 - t * t);
	},

	circInOut: function circInOut(t) {
		return (t *= 2) < 1 ? Transition.circIn(t) / 2 : Transition.circOut(t - 1) / 2 + 0.5; // TODO: redo with in-line calculation
	},

	/**
	 * Easing equation function for an elastic (exponentially decaying sine wave) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t		Current time/phase (0-1).
	 * @param {Number} [a=0]	Amplitude.
	 * @param {Number} [p=0.3]	Period.
	 * @return {Number}			The new value/phase (0-1).
	 */
	elasticIn: function elasticIn(t, a, p) {
		if (t == 0) return 0;
		if (t == 1) return 1;
		if (a === undefined) a = 0;
		if (p === undefined) p = 0.3;
		/* @type {Number} */
		var s;
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (Math.PI * 2) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (Math.PI * 2) / p));
	},

	/**
	 * Easing equation function for an elastic (exponentially decaying sine wave) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t		Current time/phase (0-1).
	 * @param {Number} [a=0]	Amplitude.
	 * @param {Number} [p=0.3]	Period.
	 * @return {Number}			The new value/phase (0-1).
	 */
	elasticOut: function elasticOut(t, a, p) {
		if (t == 0) return 0;
		if (t == 1) return 1;
		if (a === undefined) a = 0;
		if (p === undefined) p = 0.3;
		/* @type {Number} */
		var s;
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (Math.PI * 2) * Math.asin(1 / a);
		}
		return (a * Math.pow(2, -10 * t) * Math.sin((t - s) * (Math.PI * 2) / p) + 1);
	},

	/**
	 * Easing equation function for a back (overshooting cubic easing: (s+1)*t^3 - s*t^2) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t			Current time/phase (0-1).
	 * @param {Number} [s=1.70158]	Overshoot ammount: higher s means greater overshoot (0 produces cubic easing with no overshoot, and the default value of 1.70158 produces an overshoot of 10 percent).
	 * @return {Number}				The new value/phase (0-1).
	 */
	backIn: function backIn(t, s) {
		if (s === undefined) s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	/**
	 * Easing equation function for a back (overshooting cubic easing: (s+1)*t^3 - s*t^2) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t			Current time/phase (0-1).
	 * @param {Number} [s=1.70158]	Overshoot ammount: higher s means greater overshoot (0 produces cubic easing with no overshoot, and the default value of 1.70158 produces an overshoot of 10 percent).
	 * @return {Number}				The new value/phase (0-1).
	 */
	backOut: function backOut(t, s) {
		if (s === undefined) s = 1.70158;
		t--;
		return t * t * ((s + 1) * t + s) + 1;
	},

	backInOut: function backInOut(t, s) {
		if (s === undefined) s = 1.70158;
		return (t *= 2) < 1 ? Transition.backIn(t, s) / 2 : Transition.backOut(t - 1, s) / 2 + 0.5; // TODO: redo with in-line calculation
	},

	/**
	 * Easing equation function for a bounce (exponentially decaying parabolic bounce) easing in: accelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	bounceIn: function bounceIn(t) {
		return 1 - Transition.bounceOut(1 - t);
	},

	/**
	 * Easing equation function for a bounce (exponentially decaying parabolic bounce) easing out: decelerating from zero velocity.
	 *
	 * @param {Number} t	Current time/phase (0-1).
	 * @return {Number}		The new value/phase (0-1).
	 */
	bounceOut: function bounceOut(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		} else if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + .75;
		} else if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + .9375;
		} else {
			return 7.5625 * (t -= (2.625 / 2.75)) * t + .984375;
		}
	}
};